export default "__VITE_ASSET__Bhz80L$L__"